module.exports = __webpack_public_path__ + "static/media/sort-circle.398bd997.svg";